import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const markFulfillmentGroupsAsProblemPick = {
  name: "markFulfillmentGroupsAsProblemPick" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(zExt.objectId()),
    crdbLocationId: locationIdFormat.schema.nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    successCount: z.number(),
    failedCount: z.number(),
  }),
};
